import axios from 'axios';

export const betsRequest = (id: string) => axios.get(`/v1/tipsters/${id}/tips`);

export const betEditRequest = (values: any) => {
  return axios.put(`/v1/tips/${values.id}/finish`, values);
};

export const createBet = (formData: any) =>
  axios.post(`/v1/tips`, formData, {
    headers: { 'Content-Type': 'application/json' },
  });

export const uploadFile = (mediaFormData: any) => {
  return axios.post(`/v1/files`, mediaFormData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const ownedBetsRequest = (openstatus: any) => {
  if (openstatus.payload.openstatus === 'closed') {
    return axios.get(`/v1/tips/owned?limit=30&tip_result=closed`);
  } else if (openstatus.payload.openstatus === 'open') {
    return axios.get(`/v1/tips/owned?limit=40&tip_result=open`);
  } else {
    const cursor = openstatus.payload.openstatus;
    return axios.get(
      `/v1/tips/owned?limit=10&tip_result=closed&cursor=${cursor}`,
    );
  }
};
